<template>
	<div>
		<v-btn
			fab
			dark
			x-small
			outlined
			color="success"
			class="mr-1 hidden-lg-and-up"
			href="https://wa.me/51958805900"
			target="_new"
		>
			<v-icon dark>mdi-whatsapp</v-icon>
		</v-btn>
		<v-btn
			dark
			small
			rounded
			color="accent"
			class="mr-1 hidden-lg-and-up"
			href="https://wa.me/51958805900"
			target="_new"
		>
			<v-icon dark left>mdi-gift</v-icon> Demo
		</v-btn>

		<v-btn
			color="success"
			rounded
			outlined
			class="mr-1 hidden-md-and-down"
			href="https://wa.me/51958805900"
			target="_new"
		>
			<v-icon dark left>mdi-whatsapp</v-icon>WhatsApp
		</v-btn>
		<v-btn color="accent" class="hidden-md-and-down" rounded to="/demo"
			>Solicita una demo</v-btn
		>
	</div>
</template>

<script>
export default {
	props: ['data'],
};
</script>
